






















import { Component, Vue, Prop } from 'vue-property-decorator';
import RequirePasscode from '../Wallet/RequirePasscode.vue';

@Component({
  components: {
    RequirePasscode,
  },
})
export default class RequirePasscodeModal extends Vue {
  @Prop(Boolean) showDialog!: boolean;
  @Prop(Function) onClosed!: Function;
  @Prop(Function) action!: Function;
  @Prop(Function) actionComplete!: Function;
  @Prop(Function) actionError!: Function;
  @Prop(Boolean) showLoadingStateAfterSuccess!: boolean;
}
